export default __webpack_public_path__ + "static/media/DataTableBlue.4dcaa1d6.svg";